import React, {useRef, useState} from 'react'
import WizButton from '../../../../components/button/WizButton'
import useNavigation from '../../../../hooks/useNavigation'
import DeleteAnnounceModal from './DeleteAnnounceModal'

interface IProps {
    className?: string
    checkList?: string[]
}

const AnnounceSearchContainer: React.FC<IProps> = ({className, checkList}) => {
    const {goAnnounceCreate} = useNavigation()

    const announceDeleteModalRef = useRef<any>()
    return (
        <>
            <div className={'flex justify-between items-center'}>
                <div className={'flex items-center space-x-[10px]'}>
                    <WizButton text={'New Post'} className={'text-white'} type={'primary'} onClick={goAnnounceCreate} />

                    {checkList?.length > 0 && (
                        <WizButton
                            text={'Delete All'}
                            type={'red'}
                            onClick={() => announceDeleteModalRef?.current?.show()}
                        />
                    )}
                </div>
            </div>
            <DeleteAnnounceModal deleteList={checkList} ref={announceDeleteModalRef} />
        </>
    )
}

export default AnnounceSearchContainer
